module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-inputs"
  }, [_c('div', {
    staticClass: "operation"
  }, [_c('h3', [_vm._v("Operation")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.operation),
      expression: "operation"
    }],
    attrs: {
      "type": "radio",
      "id": "and",
      "value": "AND"
    },
    domProps: {
      "checked": _vm._q(_vm.operation, "AND")
    },
    on: {
      "change": function($event) {
        _vm.operation = "AND"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "and"
    }
  }, [_vm._v("AND")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.operation),
      expression: "operation"
    }],
    attrs: {
      "type": "radio",
      "id": "or",
      "value": "OR"
    },
    domProps: {
      "checked": _vm._q(_vm.operation, "OR")
    },
    on: {
      "change": function($event) {
        _vm.operation = "OR"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "or"
    }
  }, [_vm._v("OR")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.operation),
      expression: "operation"
    }],
    attrs: {
      "type": "radio",
      "id": "not",
      "value": "NOT"
    },
    domProps: {
      "checked": _vm._q(_vm.operation, "NOT")
    },
    on: {
      "change": function($event) {
        _vm.operation = "NOT"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "not"
    }
  }, [_vm._v("NOT")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.operation),
      expression: "operation"
    }],
    attrs: {
      "type": "radio",
      "id": "xor",
      "value": "XOR"
    },
    domProps: {
      "checked": _vm._q(_vm.operation, "XOR")
    },
    on: {
      "change": function($event) {
        _vm.operation = "XOR"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "xor"
    }
  }, [_vm._v("XOR")])]), _vm._v(" "), _c('div', {
    staticClass: "poly-title"
  }, [_c('h3', [_vm._v("Subject")]), _vm._v(" "), _c('span', {
    staticClass: "input-error"
  }, [_vm._v(_vm._s(_vm.suberror))])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subject),
      expression: "subject"
    }],
    domProps: {
      "value": (_vm.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subject = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "poly-title"
  }, [_c('h3', [_vm._v("Clipping")]), _vm._v(" "), _c('span', {
    staticClass: "input-error"
  }, [_vm._v(_vm._s(_vm.cliperror))])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clipping),
      expression: "clipping"
    }],
    domProps: {
      "value": (_vm.clipping)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clipping = $event.target.value
      }
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Load Example")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected_example),
      expression: "selected_example"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected_example = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((Object.keys(_vm.examples)), function(example) {
    return _c('option', [_vm._v(_vm._s(example))])
  }), 0), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "Randomize"
    },
    on: {
      "click": _vm.randomize
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-703cf121"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserInputs.vue
// module id = 56
// module chunks = 0